/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ clock: NonNullable<unknown> }} Shell_Live_RestInputs */

const en_us2_shell_live_rest = /** @type {(inputs: Shell_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Rest ${i?.clock}`)
};

const pt_br2_shell_live_rest = /** @type {(inputs: Shell_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descanso ${i?.clock}`)
};

const es_419_shell_live_rest = /** @type {(inputs: Shell_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descanso ${i?.clock}`)
};

const pt_pt2_shell_live_rest = /** @type {(inputs: Shell_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Descanso ${i?.clock}`)
};

const fr_fr2_shell_live_rest = /** @type {(inputs: Shell_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Repos ${i?.clock}`)
};

const de_de2_shell_live_rest = /** @type {(inputs: Shell_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Pause ${i?.clock}`)
};

const it_it2_shell_live_rest = /** @type {(inputs: Shell_Live_RestInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Recupero ${i?.clock}`)
};

/**
* | output |
* | --- |
* | "Rest {clock}" |
*
* @param {Shell_Live_RestInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const shell_live_rest = /** @type {((inputs: Shell_Live_RestInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shell_Live_RestInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_shell_live_rest(inputs)
	if (locale === "es-419") return es_419_shell_live_rest(inputs)
	if (locale === "pt-PT") return pt_pt2_shell_live_rest(inputs)
	if (locale === "fr-FR") return fr_fr2_shell_live_rest(inputs)
	if (locale === "de-DE") return de_de2_shell_live_rest(inputs)
	if (locale === "it-IT") return it_it2_shell_live_rest(inputs)
	return en_us2_shell_live_rest(inputs)
});
export { shell_live_rest as "shell.live_rest" }